import { render, staticRenderFns } from "./Page2.vue?vue&type=template&id=0e619069&scoped=true&"
import script from "./Page2.vue?vue&type=script&lang=ts&"
export * from "./Page2.vue?vue&type=script&lang=ts&"
import style0 from "./Page2.vue?vue&type=style&index=0&id=0e619069&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e619069",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
